"use client";

import Image from "next/image";
import clsx from "clsx";
import { JobDetailsSide } from "./JobDetailsSide";
import { useIsMobile } from "@/modules/hooks/devices/useDevice";
import { Job } from "@/modules/types/job/job";
import banner from "@/assets/imgs/banner.jpg";
import LoadingCpn from "@/modules/components/commons/Loading/loadingCpn";

export const JobListLayout = ({
  children,
  selectedJob,
}: {
  children?: React.ReactNode;
  selectedJob?: Job;
}) => {
  const isMobile = useIsMobile();

  return (
    <div className="container mx-auto py-8 px-2 md:px-8 relative">
      <div className="grid grid-cols-12 gap-6">
        {/* Job List */}
        <div
          className={clsx(
            "flex flex-col gap-3 min-h-[60vh]",
            isMobile
              ? "col-span-12"
              : !isMobile && selectedJob
                ? "col-span-4"
                : "col-span-12 lg:col-span-6",
          )}
        >
          {children}
        </div>

        {/* Job Details Panel */}
        {selectedJob && selectedJob.id.length > 0 ? (
          <div className="hidden lg:block lg:col-span-8">
            <JobDetailsSide job={selectedJob} />
          </div>
        ) : (
          <div className="hidden lg:block lg:col-span-6 sticky top-[95px] h-fit">
            <Image
              src={banner}
              width={730}
              height={278}
              className="w-full"
              alt="Together Work Banner"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export const JobListLoading = () => {
  return (
    <div className="container mx-auto py-8 px-2 md:px-8 flex justify-center items-center h-[70vh]">
      <LoadingCpn className="size-20" />
    </div>
  );
};

export const JobListSideLoading = () => {
  return (
    <div className="w-full p-5 flex flex-col justify-center items-center h-[70vh]">
      <LoadingCpn className="size-20" />
    </div>
  );
};

JobListLayout.displayName = "JobListLayout";
JobListLoading.displayName = "JobListLoading";
JobListSideLoading.displayName = "JobListSideLoading";
